export default function(can, cannot) {
  console.log(can, cannot);
  can('view', 'ContractMoving');
  can('edit', 'ContractMoving');
  can('add', 'ContractMoving');
  can('list', 'ContractMoving');
  can('move-out', 'ContractMoving');

  // account
  can('view', 'Account');
  can('add', 'Account');
  can('edit', 'Account');
  can('list', 'Account');
  can('link', 'Account');

  // company
  can('view-info', 'Company');
  // moveout follow
  can('move-out-follow', 'ContractMoving');

  // Dashboard
  can('view', 'Dashboard');

  // MyPage
  can('view', 'MyPage');

  // MyPage
  can('list', 'Message');

  // side bar
  can('view-menu', 'Dashboard');
  can('view-menu', 'Company');
  can('view-menu', 'Account');
  can('view-menu', 'TalkRoom');
  can('view-menu', 'Evacuation');
  can('view-menu', 'ContractMoving');
}